const IconSocialAdd = ({ className }) => {
    return (
        <svg
            width='25'
            height='25'
            viewBox='0 0 25 25'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
        >
            <rect
                x='0.806452'
                y='0.806482'
                width='23.3871'
                height='23.3871'
                rx='11.6935'
                stroke='#D57554'
                strokeWidth='1.6129'
                strokeDasharray='6.45 6.45'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M12.5 7.50034C12.8452 7.50034 13.125 7.78016 13.125 8.12534V11.8753H16.875C17.2202 11.8753 17.5 12.1552 17.5 12.5003C17.5 12.8455 17.2202 13.1253 16.875 13.1253H13.125V16.8753C13.125 17.2205 12.8452 17.5003 12.5 17.5003C12.1548 17.5003 11.875 17.2205 11.875 16.8753V13.1253H8.125C7.77982 13.1253 7.5 12.8455 7.5 12.5003C7.5 12.1552 7.77982 11.8753 8.125 11.8753H11.875V8.12534C11.875 7.78016 12.1548 7.50034 12.5 7.50034Z'
                fill='#D57554'
            />
        </svg>
    );
};

export default IconSocialAdd;
